import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { SecretLayout } from "../SecretLayout";
import { SecretRouterProps } from "../SecretRouterProps";

interface HomePageProps extends NSARouterMakerResult, SecretRouterProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<SecretLayout
			{...props}
		>
			<NSAHomePage {...props} />
		</SecretLayout>
	);
}